import { defineStore } from 'pinia'
import { services, getHeader } from '@/assets/js/config.js'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { useInvinityStore } from '@/stores/invinityStore'
import axios from 'axios'
import _ from 'lodash'

export const useInitialProposalStore = defineStore('initialProposalStore', {
	state: () => ({
		proposalDetail: {},
		proposalFinal: {},
		proposalListPerPage: [],
		proposalList: [],
		proposalMeta: [],
		proposalSummary: [],
		proposalSummaryTotal: 0,
		proposalPagination: {
			limit: 25,
			page: 1,
			total_data: 0,
			total_page: 1,
			from: 1,
			to: 1
		},
		filterQuery: {},
		filterOptionStatus: [],
		filterOptionSSAMgr: [],
		filterOptionCC: [],
		filterOptionCH: [],
		filterOptionProductType: [
			{
				label: 'PROPERTY',
				value: 'PROPERTY'
			},
			{
				label: 'MORTGAGE',
				value: 'MORTGAGE'
			},
			{
				label: 'OTHER',
				value: 'OTHER'
			},
			{
				label: 'CREDIT CARD',
				value: 'CREDIT_CARD'
			},
			{
				label: 'PERSONAL LOAN',
				value: 'PERSONAL_LOAN'
			},
			{
				label: 'REFINANCE',
				value: 'REFINANCE'
			},
			{
				label: 'INSURANCE',
				value: 'INSURANCE'
			},
		],
		kyc_link_status:'text-dark' //NO SEND
	}),
	actions: {
		resetProposalStore(){
			this.proposalDetail = null;
			this.kyc_link_status = 0;
		},
		setProposalDetail(data){
			this.proposalDetail = data;
		},
		setCurrentPage(page) {
			this.proposalPagination.page = page;
		},
		setPerPage(value) {
			this.proposalPagination.limit = value;
		},
		setFilter(filter) {
			this.filterQuery = { ...this.filterQuery, ...filter }

			//RESET HISTORY
			this.proposalListPerPage = [];
			this.proposalPagination = {
				limit: 25,
				page: 1,
				total_data: 0,
				total_page: 1
			}
		},
		setKycLinkStatus(sts){
			this.kyc_link_status = sts
		},
		clearFilter() {
			this.filterQuery = {}

			//RESET HISTORY
			this.proposalListPerPage = [];
			this.proposalPagination = {
				limit: 25,
				page: 1,
				total_data: 0,
				total_page: 1
			}
		},
		async getProposalListSummary() {
			let params = {
				is_full_content: false,
				is_only_summary: true,
				pagination: {
					page: this.proposalPagination.page,
					limit: this.proposalPagination.limit,
					order: {
						psal_id: 'DESC'
					}
				}
			};

			if (!_gHlp.isEmpty(this.filterQuery)) {
				params['search'] = this.filterQuery;
			}

			let urlSearchParams = _gHlp.generateQueryParams(params);

			try {
				const res = await axios.get(`${services.initial_proposal}proposals?${urlSearchParams}`, { headers: getHeader() });
				if (!_gHlp.isEmpty(res.data)) {
					this.proposalSummary = res.data;
					this.proposalSummaryTotal = !_gHlp.isEmpty(this.proposalPagination.total_data) ? this.proposalPagination.total_data : 0;
				}
			} catch (e) {
				this.proposalSummary = []
				console.log(e);
			}
		},
		async getProposalList() {

			let params = {
				is_full_content: false,
				// is_only_summary:false,
				pagination: {
					page: this.proposalPagination.page,
					limit: this.proposalPagination.limit,
					order: {
						psal_id: 'DESC'
					}
				}
			};

			if (!_gHlp.isEmpty(this.filterQuery)) {
				params['search'] = this.filterQuery;
			}

			let urlSearchParams = _gHlp.generateQueryParams(params);

			try {
				const res = await axios.get(`${services.initial_proposal}proposals?${urlSearchParams}`, { headers: getHeader() });
				if (!_gHlp.isEmpty(res.data.content)) {
					this.proposalList = res.data.content;
					this.proposalMeta = res.data.meta;
					this.proposalPagination = res.data.pagination;
				} else {
					this.proposalList = [];
					this.proposalMeta = []
					this.proposalPagination = {
						limit: 25,
						page: 1,
						total_data: 0,
						total_page: 1,
						from: 1,
						to: 1
					};
				}
			} catch (e) {
				this.proposalList = []
				this.proposalMeta = []
				this.proposalPagination = {
					limit: 20,
					page: 1,
					total_data: 0,
					total_page: 1,
					from: 1,
					to: 1
				};
				console.log(e);
			}
		},
		async createInitialProposal(customer_id) {
			try {
				const data = {
					"psal_customer_id": customer_id,
					"psal_main_status": Draft,
					"psal_sub_status": Draft,
					"psal_management_status": null
				}
				const res = await axios.post(services.initial_proposal + '/proposal', data, { headers: getHeader() })
				return res
			} catch (e) {
				console.log('Initial Proposal Store (createInitialProposal) failed:' + e.response.data.message)
				throw e
			}
		},
		async syncCustomerFinancial(customerIncome, customerVariableExpenses, financialIncome, psal_id) {
			try {
				let params = {
					customer_income: customerIncome,
					financial_income: financialIncome,
					customer_variable_expenses: customerVariableExpenses
				}
				const res = await axios.post(services.initial_proposal + 'proposal/sync-customer-financial/' + psal_id, params, { headers: getHeader() })
				console.log(res);
				this.proposalDetail = res.data
				return this.proposalDetail
			} catch (e) {
				console.log(e);
				console.log('Sync Proposal financial failed:' + e.response.data.message)
				throw e
			}
		},
		async getFilterOptions() {
			try {
				const res = await axios.get(services.initial_proposal + 'proposal/filter-options', { headers: getHeader() })
				if (!_gHlp.isEmpty(res.data)) {
					if (!_gHlp.isEmpty(res.data.filterOptionStatus)) {
						this.filterOptionStatus = _.map(res.data.filterOptionStatus, (o) => { return { label: o, value: o } });
					}
					if (!_gHlp.isEmpty(res.data.filterOptionSSAMgr)) {
						this.filterOptionSSAMgr = [];
						for (const id of res.data.filterOptionSSAMgr) {
							let user = await useAccessControlStore().getUser(id);
							this.filterOptionSSAMgr.push({
								label: user.name,
								value: user.id
							})
						}
					}
					if (!_gHlp.isEmpty(res.data.filterOptionCC)) {
						this.filterOptionCC = [];
						for (const id of res.data.filterOptionCC) {
							let user = await useAccessControlStore().getUser(id);
							this.filterOptionCC.push({
								label: user.name,
								value: user.id
							})
						}
					}
					if (!_gHlp.isEmpty(res.data.filterOptionCH)) {
						this.filterOptionCH = [];
						for (const id of res.data.filterOptionCH) {
							let user = await useAccessControlStore().getUser(id);
							this.filterOptionCH.push({
								label: user.name,
								value: user.id
							})
						}
					}
				}
			} catch (e) {
				_gNotif.errorFunction(e)
			}
		},

		async updateProposal(id, params) {
			return await axios.post(services.initial_proposal + 'proposal/' + id, params, { headers: getHeader() })
				.then(res => {
					this.proposalDetail = res.data;
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},

		async generateAppendix(id, params={}) {
			return await axios.post(services.initial_proposal + 'appendix/generate/' + id, params, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},

		//PROMISE METHOD
		getProposal(psal_id = null) {
			if(_gHlp.isEmpty(psal_id)) psal_id = this.proposalDetail.psal_id

			return new Promise((resolve, reject) => {
				if(_gHlp.isEmpty(psal_id)){
					resolve(null)
				}else{
					axios.get(services.initial_proposal + 'proposal/detail/' + psal_id, { headers: getHeader() })
					.then(async (res) => {
						resolve(res.data)
					})
					.catch(e => {
						reject(e)
					})
				}
			});
		},

		async generateFinal(psal_id = null) {
			if(_gHlp.isEmpty(psal_id)) psal_id = this.proposalDetail.psal_id
			return await axios.post(services.initial_proposal + 'proposal/sync-final/' + psal_id, {}, { headers: getHeader() })
				.then(res => {
					return res.data;
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				});
		},

		//FEES CHARGES
		getFeesChargesList(params) {
			return new Promise((resolve, reject) => {
					let queryParams = _gHlp.generateQueryParams(params);
					axios.get(services.initial_proposal + 'fees-charge?' + queryParams, { headers: getHeader() })
					.then(async (res) => {
						resolve(_gHlp.getValue(res,'data'))
					})
					.catch(e => {
						reject(e)
					})		
			});
		},
		async bulkUpSertFeesCharges(psal_id, newlistItems = [], oldListItems = [], sync = false) {
			if(_gHlp.isEmpty(psal_id)) return false;

			var axiosCalls = []

			var new_feesCharges = newlistItems.filter(item => _gHlp.isEmpty(item.pfee_id))
			var current_feesCharges = newlistItems.filter(item => !_gHlp.isEmpty(item.pfee_id))

			new_feesCharges.forEach((item) => {
					let dataPrams = {
						pfee_psal_id: psal_id,
						pfee_type: item.pfee_type,
						pfee_outstanding: item.pfee_outstanding,
						pfee_description: item.pfee_description
					}	
					axiosCalls.push(axios.post(services.initial_proposal + 'fees-charge', dataPrams, {headers: getHeader()} ))
			})

			current_feesCharges.forEach((item) => {
					const original_item = oldListItems.find(o_item => o_item.pfee_id === item.pfee_id)
					if(original_item && !_.isEqual(original_item, item)){
						axiosCalls.push(axios.put(services.initial_proposal + 'fees-charge/'+item.pfee_id, item, {headers: getHeader()} ))
					}
			})

			// check for delete item
			oldListItems.forEach((item) => {
					const existing_item = newlistItems.find(e_item => e_item.pfee_id === item.pfee_id)
					if(!existing_item){
							axiosCalls.push(axios.delete(services.initial_proposal + 'fees-charge/' + item.pfee_id, {headers: getHeader()} ))
					}
			})
			try {
				await Promise.all(axiosCalls)
						.then(res  => {
								if(axiosCalls.length > 0){
										if(sync){
											useInvinityStore().syncToLms(psal_id)
										}
								}
						})
						.catch(e => {
							_gNotif.errorFunction(e)
						})
				return true;		
			} catch (error) {
				return false;
			}		
		},

		//PROPOSAL COMMITMENT
		getProposalCommitmentList(params) {
			return new Promise((resolve, reject) => {
					let queryParams = _gHlp.generateQueryParams(params);
					axios.get(services.initial_proposal + 'ccris-item?' + queryParams, { headers: getHeader() })
					.then(async (res) => {
						resolve(_gHlp.getValue(res,'data'))
					})
					.catch(e => {
						reject(e)
					})		
			});
		},
		async createProposalCommitment(data) {
			try {
				const res = await axios.post(services.initial_proposal + 'ccris-item', data, { headers: getHeader() })
				return res.data
			} catch (e) {
				console.log('Update Proposal commitment failed:' + e.response.data.message)
				throw e
			}
		},
		async updateProposalCommitment(data, pcom_id) {
			try {
				const res = await axios.post(services.initial_proposal + 'ccris-item/' + pcom_id, data, { headers: getHeader() })
				return res.data
			} catch (e) {
				console.log('Update Proposal commitment failed:' + e.response.data.message)
				throw e
			}
		},
		async deleteProposalCommitment(pcom_id) {
			try {
				await axios.post(services.initial_proposal +'ccris-item/delete/'+pcom_id, null, {headers:getHeader()});
				return true;
			} catch (e) {
				_gNotif.errorFunction(e)
				return false;
			}
		},

		//KYC QUESTION
		getKycQuestionList(params) {
			return new Promise((resolve, reject) => {
					let queryParams = _gHlp.generateQueryParams(params);
					axios.get(services.initial_proposal + 'kyc-question?' + queryParams, { headers: getHeader() })
					.then(async (res) => {
						resolve(_gHlp.getValue(res,'data'))
					})
					.catch(e => {
						reject(e)
					})		
			});
		},
		async bulkUpSertKycQuestions(psal_id, newlistItems = [], oldListItems = []) {
			if(_gHlp.isEmpty(psal_id)) return false;

			var axiosCalls = []

			var new_items = newlistItems.filter(item => _gHlp.isEmpty(item.pkyq_id))
			var current_items = newlistItems.filter(item => !_gHlp.isEmpty(item.pkyq_id))

			new_items.forEach((item) => {
					let dataPrams = {
						pkyq_psal_id: psal_id,
						pkyq_sequence: item.pkyq_sequence,
						pkyq_question: item.pkyq_question,
						pkyq_answer: item.pkyq_answer,
						pkyq_remark: item.pkyq_remark,
						pkyq_advisor_id: item.pkyq_advisor_id,
					}
					axiosCalls.push(axios.post(services.initial_proposal + 'kyc-question', dataPrams, {headers: getHeader()} ))
			})

			current_items.forEach((item) => {
					const original_item = oldListItems.find(o_item => o_item.pkyq_id === item.pkyq_id)
					if(original_item && !_.isEqual(original_item, item)){
						axiosCalls.push(axios.put(services.initial_proposal + 'kyc-question/'+item.pkyq_id, item, {headers: getHeader()} ))	
					}
			})

			// check for delete item
			oldListItems.forEach((item) => {
					const existing_item = newlistItems.find(e_item => e_item.pkyq_id === item.pkyq_id)
					if(!existing_item){
							axiosCalls.push(axios.delete(services.initial_proposal + 'kyc-question/' + item.pkyq_id, {headers: getHeader()} ))
					}
			})
			try {
				await Promise.all(axiosCalls)
						.then(res  => {
						})
						.catch(e => {
							_gNotif.errorFunction(e)
						})
				return true;		
			} catch (error) {
				return false;
			}		
		},

		//REPAYMENT:
		getRepaymentList(params) {
			return new Promise((resolve, reject) => {
					let queryParams = _gHlp.generateQueryParams(params);
					axios.get(services.initial_proposal + 'repayment?' + queryParams, { headers: getHeader() })
					.then(async (res) => {
						resolve(_gHlp.getValue(res,'data'))
					})
					.catch(e => {
						reject(e)
					})		
			});
		}, 
		async bulkUpSertRepayments(psal_id, newlistItems = [], oldListItems = [], sync = false) {
			if(_gHlp.isEmpty(psal_id)) return false;

			var axiosCalls = []

			var new_items = newlistItems.filter(item => _gHlp.isEmpty(item.prep_id))
			var current_items = newlistItems.filter(item => !_gHlp.isEmpty(item.prep_id))

			new_items.forEach((item) => {
					let dataPrams = {
						prep_psal_id: psal_id,
						prep_proposed_via: item.prep_proposed_via,
						prep_facility: item.prep_facility,
						prep_process_amount: item.prep_process_amount,
						prep_charge_rate: item.prep_charge_rate,
						prep_period: item.prep_period
					}	
					axiosCalls.push(axios.post(services.initial_proposal + 'repayment', dataPrams, {headers: getHeader()} ))
			})

			current_items.forEach((item) => {
					const original_item = oldListItems.find(o_item => o_item.prep_id === item.prep_id)
					if(original_item && !_.isEqual(original_item, item)){
						axiosCalls.push(axios.put(services.initial_proposal + 'repayment/'+item.prep_id, item, {headers: getHeader()} ))
					}
			})

			// check for delete item
			oldListItems.forEach((item) => {
					const existing_item = newlistItems.find(e_item => e_item.prep_id === item.prep_id)
					if(!existing_item){
							axiosCalls.push(axios.delete(services.initial_proposal + 'repayment/' + item.prep_id, {headers: getHeader()} ))
					}
			})
			try {
				await Promise.all(axiosCalls)
						.then(res  => {
								if(axiosCalls.length > 0){
										if(sync){
											useInvinityStore().syncToLms(psal_id)
										}
								}
						})
						.catch(e => {
							_gNotif.errorFunction(e)
						})
				return true;		
			} catch (error) {
				return false;
			}		
		}

	}
})